export default "__VITE_ASSET__BSPPNgGr__"